import { useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import Swiper from "react-id-swiper";
import Slider from "react-slick";
import {
  FaArrowRight,
  FaArrowLeft,
  FaAngleRight,
  FaAngleLeft,
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import ComingSoon from "../common/ComingSoon";
import Image from "next/image"

const images = [
  {
    img: "/assets/cars/rent-cars.webp",
    title: "Rent a Car",
    descrtiption: (
      <>
        View prices for daily,, weekly or monthly rental and{" "}
        <span className="one-line text-white">request to book now!</span>
      </>
    ),
  },
  {
    img: "/assets/cars/insurance.webp",
    title: "Car Insurance",
    descrtiption: (
      <>
        Best prices and rewards from our insurance partners.{" "}
        <span className="one-line text-white">Request quotation now!</span>
      </>
    ),
  },
  {
    img: "/assets/cars/Fleet2.webp",
    title: "Fleet Vehicle Services",
    descrtiption: (
      <>
        Our digital solution is customized to your fleet vehicle maintenance
        needs!
      </>
    ),
  },
  {
    img: "/assets/cars/rent-cars.webp",
    title: "Rent a Car",
    descrtiption: (
      <>
        View prices for daily, weekly or monthly rental and{" "}
        <span className="one-line text-white">request to book now!</span>
      </>
    ),
  },
  {
    img: "/assets/cars/insurance.webp",
    title: "Car Insurance",
    descrtiption: (
      <>
        Best prices and rewards from our insurance partners.{" "}
        <span className="one-line text-white">Request quotation now!</span>
      </>
    ),
  },
  {
    img: "/assets/cars/Fleet2.webp",
    title: "Fleet Vehicle Services",
    descrtiption: (
      <>
        Our digital solution is customized to your fleet vehicle maintenance
        needs!
      </>
    ),
  },
];

const RentCar = () => {
  const [active, setActive] = useState("1");
  const [imgIndex, setImgIndex] = useState(0);
  const [show, setShow] = useState(false);

  const params = {
    pagination: ".swiper-pagination",
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "3",
    activeSlideKey: active,
    coverflow: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    loop: false,
    breakpoints: {
      576: {
        slidesPerView: 3,
      },
      320: {
        slidesPerView: 2,
      },
    },
  };

  const settings = {
    autoplay: true,
    infinite: true, //to allow the slides to show infinitely
    lazyLoad: true,
    autoplaySpeed: 2000,
    speed: 300, //this is the speed of slider in ms
    slidesToShow: 3, //number of slides to show up on screen
    centerMode: true,
    centerPadding: 0,
    nextArrow: <NextArrow />, //imported from 'react-icons'
    prevArrow: <PrevArrow />, //imported from 'react-icons'
    beforeChange: (current, next) => setImgIndex(next),
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div
      style={{
        // height: "360px",
        background: "#f8f9fa",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
      id="rent"
    >
      {images.length > 0 && (
        <Slider
          className="w-100 d-flex align-items-center justify-content-between"
          {...settings}
        >
          {images.map((data, idx) => (
            <div
              className={idx === imgIndex ? "slide activeSlide" : "slide"}
              onClick={() => setShow(true)}
            >
              <div
                style={{
                  // position: "absolute",
                  // left: 0,
                  width: "100%",
                  height: 380,
                  position: "relative",
                }}
                // className="profile"
              >
                <Image
                  src={data.img}
                  alt={data.title}
                  layout="fill"
                  objectFit="cover"
                />
              </div>
              {/* <img src={data.img} alt={data.title} width="100%" /> */}
              <div className="title w-100">
                <h2>{data.title}</h2>
                <p className="m-0 px-sm-4 px-1">
                  {data.descrtiption}{" "}
                  <span>
                    View More <FaAngleRight />
                  </span>
                </p>
              </div>
            </div>
          ))}
        </Slider>
      )}
      <ComingSoon show={show} handleClose={() => setShow(false)} />
      {/* <Swiper {...params}>
             
              <div key={'0'} className="rent-car-st-open" style={{background:"linear-gradient(to bottom, rgba(242,12,66,0.25), rgba(242,12,66,0.80)), url('/assets/cars/1.jpeg') center center no-repeat",cursor:'pointer'}} onClick={()=>{
                setActive("0")
                }}>
                <div className="rent-car-text">Insurance</div>
                <div className="rent-car-text-sub">Car rentals at lowest and affordable prices</div>
              </div>
              <div key={'1'} className="rent-car-st-open" style={{background:"linear-gradient(to bottom, rgba(255,234,0,0.25), rgba(255,234,0,0.80)), url('/assets/cars/3.jpeg') center center no-repeat",cursor:'pointer'}} onClick={()=>{
                setActive("1")
                }}>
                <div className="rent-car-text">Rent a Car</div>
                <div className="rent-car-text-sub">Car rentals at lowest and affordable prices</div>
              </div>
              <div key={'2'} className="rent-car-st-open" style={{background:"linear-gradient(to bottom, rgba(17,0,230,0.25), rgba(17,0,230,0.80)), url('/assets/cars/4.jpeg') center center no-repeat",cursor:'pointer'}} onClick={()=>{
                setActive("2")
                }}>
                <div className="rent-car-text">Fleet</div>
                <div className="rent-car-text-sub">Car rentals at lowest and affordable prices</div>
              </div>
              
          </Swiper> */}
      {/* <Container>
        <Row>
          <Col md={4}>
            <img
              src="/assets/cars/rent.webp"
              width="100%"
              style={{
                height: 460,
                borderRadius: 15,
                objectFit: "cover",
              }}
            />
            <div className="image-layer">
              <h2 className="text-white px-3">Rent a Car</h2>
            </div>
            
          </Col>
          <Col md={4}>
            <div  className="position-relative">
              <img
                src="/assets/cars/insurance.webp"
                width="100%"
                style={{
                  height: 210,
                  borderRadius: 15,
                  objectFit: "cover",
                }}
              />
              <div className="image-layer">
                <h2 className="text-white px-3">Insurance</h2>
              </div>
            </div>
            <div className="position-relative" style={{ marginTop: 30}}>
              <img
                src="/assets/cars/fleet.webp"
                width="100%"
                style={{
                  height: 210,
                  borderRadius: 15,
                  objectFit: "cover",
                }}
              />
              <div className="image-layer">
                <h2 className="text-white px-3">Fleet Service</h2>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <img
              src="/assets/cars/super-car.webp"
              width="100%"
              style={{
                height: 460,
                borderRadius: 15,
                objectFit: "cover",
              }}
            />
            <div className="image-layer">
              <h2 className="text-white px-3">Super Car</h2>
            </div>
          </Col>
        </Row>
      </Container> */}
    </div>
  );
};

const NextArrow = ({ onClick }) => {
  return (
    <div className="arrow next" onClick={onClick}>
      <FaArrowAltCircleRight />
    </div>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <div className="arrow prev" onClick={onClick}>
      <FaArrowAltCircleLeft />
    </div>
  );
};

export default RentCar;

// {data.map((e,index)=>(
//   e.color == "yellow" ?
//    <div className="rent-car-st-open p-2" style={{background:e.color,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',width:widthS}}>
//     {widthS=='250px' && <div className="rent-car-text" style={{fontSize:65,fontWeight:'bolder'}}>Rent</div>}
//     {widthS=='250px' &&<div className="rent-car-text" style={{fontSize:65,fontWeight:'400',marginTop:'-20px'}}>a Car</div>}
//     {widthS=='250px' && <div className="rent-car-text" style={{textAlign:'center'}}>Car rentals at lowest and affordable prices</div>}
//   </div>
//  :
//   <div className="rent-car-st" onMouseOver={onHover} onMouseOut={onHoverOut} style={{background:e.color}}>
//   </div>
// ))}

// pagination: {
//   el: ".swiper-pagination",
//   clickable: true
// },
// navigation: {
//   nextEl: ".swiper-button-next",
//   prevEl: ".swiper-button-prev"
// },
